import ChangePasswordForm from "../../components/Forms/ChangePasswordForm";

const ChangePassword = () => {
  return (
    <div>
      <ChangePasswordForm />
    </div>
  );
};

export default ChangePassword;
